/**
 * The talent application's portfolio link (Traci, 23 Sep 2026: a link only, no photo uploads, so Nautica sees the
 * portfolio where the applicant hosts it instead of a compressed upload). Required.
 *
 * Accepts "yourwebsite.com", "www.site.com/gallery" or a full https link; returns the https link, or null when it is
 * not something a browser can open.
 */
export function normalizePortfolioUrl(input) {
  const raw = String(input || '').trim()
  if (!raw || /\s/.test(raw)) return null
  const withScheme = /^https?:\/\//i.test(raw) ? raw : `https://${raw.replace(/^\/+/, '')}`
  try {
    const u = new URL(withScheme)
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null
    if (!/\.[a-z]{2,}$/i.test(u.hostname)) return null
    return u.toString()
  } catch {
    return null
  }
}
